import { Common } from "@bonusx-global/bx-design-system";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import { headerHeight } from "../../../../../R";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class FullScreenRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return false;
  }
  get headerAvailable(): boolean {
    return false;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      layoutStyles: {
        mobile: { backgroundColor: Common.white.main },
        desktop: {
          backgroundColor: Common.white.main,
          height: "100vh !important",
        },
      },
      contentLayoutStyles: {
        mobile: {
          height: `calc(100vh - ${headerHeight})`,
        },
        desktop: {
          padding: "0px!important",
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {};
  }
}
